import { useEffect } from 'react';
import { isEqual } from 'lodash';
import { GridSettingsStore } from '@nexelem/table';
import { Order } from '@nexelem/api';

export const useSyncOrderingWithStore = (store: GridSettingsStore | undefined, ordering: Order | undefined) => {
  useEffect(() => {
    if (!store) {
      return;
    }

    const currentStoreOrdering = store.getState().currentOrdering;

    if (!isEqual(currentStoreOrdering, ordering)) {
      store.getState().setOrdering(ordering);
    }
  }, [store, ordering]);
};
